export default ({ form, field }) => ({ name }) => (
  form.setFieldValue(field.name, name)
)
